import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BKJButton } from '../BKJButton/index.js';
import { getDesignLibraryElementNode } from '../BKJSelect/utils/getDesignLibraryElementNode.js';
import { mergeRefs } from '../BKJSelect/utils/mergeRefs.js';
import { Portal } from '../Portal/Portal.js';
import { useClickOutside, useMouseOutside } from '../../hooks/index.js';
import { Fragment, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { usePopper } from 'react-popper';
import { BKJIcon } from '../index.js';
import { BKJDropdownMenuWrapper } from './BKJDropdownMenu.styled.js';
export const BKJDropdownMenu = ({ children, label, listRightLeftOffset = 0, ...buttonProps }) => {
    const [isOpen, setOpen] = useState(false);
    const buttonRef = useRef();
    const dropdownRef = useRef();
    const [buttonElement, setButtonElement] = useState();
    const [dropdownElement, setDropdownElement] = useState();
    const [targetElement, setTargetElement] = useState(getDesignLibraryElementNode('dropdown-root'));
    const handleClose = useCallback((event) => {
        if (buttonRef?.current && !buttonRef?.current.contains(event.target)) {
            if (dropdownRef?.current && !dropdownRef?.current.contains(event.target)) {
                setOpen(false);
            }
        }
    }, []);
    useClickOutside([buttonRef && buttonRef.current, dropdownRef && dropdownRef.current, dropdownElement], handleClose);
    useMouseOutside([buttonRef && buttonRef.current, dropdownRef && dropdownRef.current, dropdownElement], handleClose);
    useEffect(() => {
        if (!targetElement) {
            const element = document.createElement('div');
            element.setAttribute('id', 'dropdown-root');
            document.body.prepend(element);
            setTargetElement(element);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const modifiers = useMemo(() => {
        return [
            {
                name: 'offset',
                options: {
                    offset: () => [listRightLeftOffset, 0],
                },
            },
            {
                name: 'sameWidth',
                enabled: !buttonProps.width,
                phase: 'beforeWrite',
                requires: ['computeStyles'],
                fn({ state }) {
                    if (buttonProps.width)
                        return void 0;
                    state.styles.popper.minWidth = `${state.rects.reference.width}px`;
                    state.styles.popper.maxWidth = `${state.rects.reference.width}px`;
                },
                effect({ state }) {
                    if (buttonProps.width)
                        return void 0;
                    state.elements.popper.style.minWidth = `${state.elements.reference.offsetWidth}px`;
                    state.elements.popper.style.maxWidth = `${state.elements.reference.offsetWidth}px`;
                },
            },
        ];
    }, []); // eslint-disable-line
    const { styles, attributes } = usePopper(buttonElement, dropdownElement, {
        modifiers,
    });
    const popperStyles = useMemo(() => ({
        ...styles['popper'],
        maxHeight: 'auto',
        height: 'auto',
        minHeight: 'auto',
    }), [styles]);
    const popperProps = useMemo(() => ({
        style: popperStyles,
        ...attributes['popper'],
    }), [attributes, popperStyles]);
    return (_jsxs(Fragment, { children: [_jsxs(BKJButton, { ...buttonProps, ref: mergeRefs([buttonRef, setButtonElement]), onMouseOver: () => setOpen(true), onClick: (e) => {
                    buttonProps.onClick && buttonProps.onClick(e);
                    setOpen(false);
                }, children: [_jsx("div", { children: label }), _jsx(BKJIcon, { color: "White", iconName: isOpen ? 'ArrowUp' : 'ArrowDown' })] }), isOpen && targetElement && (_jsx(Portal, { targetElement: targetElement, children: _jsx(BKJDropdownMenuWrapper, { ...popperProps, ref: mergeRefs([dropdownRef, setDropdownElement]), onClick: () => setOpen(false), children: children }) }))] }));
};
//# sourceMappingURL=BKJDropdownMenu.js.map